import React from 'react';
import {AppBar, Backdrop, Box, Grid, Toolbar} from "@mui/material";
import IconButton from '@mui/material/IconButton';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import logo from '../../../assets/images/admin/logo.png'
import MenuIcon from "@mui/icons-material/Menu";
import {GetState, SetState} from "../../../redux/reduxhelper";
import {useDispatch} from "react-redux";



const Header = () => {
    const dispatch = useDispatch();
    const isCollapsed = GetState("IS_COLLAPSED", true);
    const setIsCollapsed = (value) => {
        dispatch(SetState("IS_COLLAPSED", value))
    }
    return (
        <Box sx={{flexGrow: 1}}>
            <AppBar position="static">
                <Toolbar sx={{background:"#592EA9"}}>
                    <MenuIcon onClick={() => {
                        setIsCollapsed(!isCollapsed)
                    }} sx={{display: {xs: 'inline', md: 'none'}, mr:{xs:5}}}/>

                    <Backdrop open={!isCollapsed} onClick={() => {
                        setIsCollapsed(!isCollapsed)
                    }} sx={{zIndex:1296, display: {xs: 'inline', md: 'none'}}}/>

                    <Grid sx={{flexGrow: 1}}>
                        <img src={logo} alt="logo" style={{width:"80px",height:"auto"}}/>
                    </Grid>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        sx={{mr: 2}}
                    >
                        <NotificationsNoneRoundedIcon/>
                    </IconButton>

                </Toolbar>
            </AppBar>
        </Box>
    );
};

export default Header;